import React from "react";
import { AvatarProfile, GetAvatarProfile, GetAvatarService } from "../Shared/Avatar/AvatarProfile";
import { GetSVGAvatarPath } from "../Shared/Avatar/SVGAvatarPaths";
import { UIConfigContext } from "./UIConfigContext";

export type ProfileDisplayProps = {
    nickname : string;
    height : number;
}

export const ProfileDisplay = ({nickname, height} : ProfileDisplayProps) : JSX.Element => {

    const uiConfig = React.useContext(UIConfigContext);

    const profile = React.useRef<AvatarProfile | null>(null);
    const profilePicture = React.useRef<string[]>([]);
    const otherBadges = React.useRef<{ [key: string]: string[] }>({});
    const rcRef = React.useRef<number>(0);
    const ppScale = React.useRef<number>(-1);
    const ppMove = React.useRef<number[]>([]);
    const bdgScale = React.useRef<{ [key: string]: number }>({});
    const bdgMove = React.useRef<{ [key: string]: number[] }>({});
    const [rc, setRC] = React.useState<number>(0);

    const width3 = Math.floor(uiConfig.width / 3);

    React.useEffect(() => {
        var update = false;
        if (ppScale.current === -1 && profilePicture.current.length > 0) {
            var minScale = 1.0;
            profilePicture.current.forEach((_value, index) => {
                const el = document.getElementById('ProfileDisplay_pp_' + index);
                if (el !== null) {
                    const path: SVGPathElement = (el as any) as SVGPathElement;
                    const rect = path.getBBox();
                    const size = Math.max(rect.width, rect.height);
                    const scale = width3 / size;
                    if(scale > 1.0) {
                        const stopHere = 'Stop Here';
                    }
                    console.log('profile scale: ' + scale);
                    minScale = Math.min(minScale, scale);
                }
            })

            ppScale.current = minScale;
            console.log('min profile scale: ' + minScale);

            update = true;
        }
        else if (profilePicture.current.length > 0 && ppMove.current.length === 0) {
            var minX = 1000000;
            var minY = 1000000;
            profilePicture.current.forEach((_value, index) => {
                const el = document.getElementById('ProfileDisplay_pp_' + index);
                if (el !== null) {
                    const path: SVGPathElement = (el as any) as SVGPathElement;
                    const rect = path.getBBox();
                    minX = Math.min(minX, rect.x);
                    minY = Math.min(minY, rect.y);
                    console.log('profile element (x,y) =>(' + rect.x + ' , ' + rect.y + ')');
                }
            })
            ppMove.current = [-minX, -minY];
            console.log('profile min pos (x,y) =>(' + minX + ' , ' + minY + ')');

            update = true;
        }

        if (profile.current !== null) {
            profile.current.achievements.forEach((achievement, aindex) => {
                const paths = otherBadges.current[achievement.symbol];
                if (paths.length > 0 && bdgScale.current[achievement.symbol] === undefined) {
                    var minScale = 1.0;
                    paths.forEach((_value, bindex) => {
                        const el = document.getElementById('ProfileDisplay_bdg_' + aindex + '_' + bindex);
                        if (el !== null) {
                            const path: SVGPathElement = (el as any) as SVGPathElement;
                            const rect = path.getBBox();
                            const size = Math.max(rect.width, rect.height);
                            const scale = (0.8 * width3) / size;
                            minScale = Math.min(minScale, scale);
                        }
                    })

                    bdgScale.current[achievement.symbol] = minScale;
                    update = true;
                }
                else if (paths.length > 0 && bdgMove.current[achievement.symbol] === undefined) {
                    var minX = 1000000;
                    var minY = 1000000;
                    paths.forEach((_value, bindex) => {
                        const el = document.getElementById('ProfileDisplay_bdg_' + aindex + '_' + bindex);
                        if (el !== null) {
                            const path: SVGPathElement = (el as any) as SVGPathElement;
                            const rect = path.getBBox();
                            minX = Math.min(minX, rect.x);
                            minY = Math.min(minY, rect.y);
                        }
                    })
                    bdgMove.current[achievement.symbol] = [-minX + 50, -minY];
        
                    update = true;
                }
            })
        }

        if (update) {
            rcRef.current++;
            setRC(rcRef.current);
        }
    })

    const profileBoundingBox = (rect: DOMRect) => {
        if (ppScale.current === -1) {
            const size = Math.max(rect.width, rect.height);
            ppScale.current = width3 / size;
            rcRef.current++;
            setRC(rcRef.current);
        }

    }

    const badgeBoundingBox = () => {

    }

    const loadProfile = async () => {
        profile.current = await GetAvatarService(nickname);
        profilePicture.current = GetSVGAvatarPath(profile.current.profilePicture);
        profile.current.achievements.forEach((achievement) => {
            otherBadges.current[achievement.symbol] = GetSVGAvatarPath(achievement.symbol);
        })
        rcRef.current++;
        setRC(rcRef.current);
    }
    //, marginRight : '20px' e6007e , justifyContent : 'left', textAlign : 'left' , border : '2px solid d1d130' , paddingLeft : '10px', paddingRight : '10px', marginLeft : '10px' , paddingBottom : '5px', marginTop : '10px', marginBottom : '10px', maxWidth : (0.65 * width3) + 'px'

    const profileScale = ppScale.current < 0 ? 1 : ppScale.current;
    const profileMove = ppMove.current.length === 0 ? [0, 0] : ppMove.current;

    const profileT = "scale(" + profileScale + ") translate(" + profileMove[0] + ' ' + profileMove[1] + ')';

    const badgeT : {[key : string] : string} = {};
    if(profile.current !== null)
        profile.current.achievements.forEach((achievement)=> {
           const scale = bdgScale.current[achievement.symbol] === undefined ? 1.0 : bdgScale.current[achievement.symbol];
           const move = bdgMove.current[achievement.symbol] === undefined ? [0,0] : bdgMove.current[achievement.symbol];
           badgeT[achievement.symbol] = "scale(" + scale + ") translate(" + move[0] + ' ' + move[1] + ')';
    })

    const _something = profileT + '';

    const interests: Array<{ name: string, values: string[] }> = profile.current !== null ? Object.keys(profile.current.interests).map((key) => {
        return { name: key, values: profile.current !== null ? profile.current.interests[key] : [] };
    }) : [];


    if (profile.current === null)
        loadProfile();

    return <div style={{
        backgroundColor: 'black',
        minHeight: height + 'px',
        height: height + 'px',
        maxHeight: height + 'px',
        minWidth: uiConfig.width + 'px',
        width: uiConfig.width + 'px',
        maxWidth: uiConfig.width + 'px',
        overflow: 'auto',
        display: 'fex',
        flexDirection: 'column'
    }}>
        {(profile.current === null) ? <span style={{ fontFamily: 'roboto', fontSize: '20px', fontWeight: 400, color: 'white', textAlign: 'center' }}>Loading Profile...</span>
            : <div style={{ display: 'flex', flexDirection: 'row', backgroundColor: '#131313', borderRadius: '10px' }}>
                <svg width={width3} height={width3} style={{ marginTop: '20px', position : 'relative' }} ><g transform={profileT}>
                    {
                        profilePicture.current.map((p, index) => {
                            return <path fill='white' d={p} id={'ProfileDisplay_pp_' + index} ></path>
                        })
                    }
                </g>
                </svg>
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    minWidth: (uiConfig.width - width3) + 'px',
                    maxWidth: (uiConfig.width - width3) + 'px',
                    justifyContent : 'right',
                    textAlign : 'right'
                }}>

                    <span style={{ fontFamily: 'roboto', fontSize: '20px', fontWeight: 800, color: 'white', textAlign: 'right', marginRight: '20px', marginTop: '5px' }}>{nickname}</span>

                    <div style={{ display: 'flex', flexDirection: 'row', marginTop: '5px', justifyContent: 'right', textAlign: 'right', marginRight: '20px' }}>
                        <span style={{ fontSize: '18px' }}>{profile.current.fanStatus.verificationTick.symbol}</span>
                        <span style={{ fontFamily: 'roboto', fontSize: '14px', fontWeight: 400, color: 'white', textAlign: 'right' , marginTop: '6px', marginLeft : '5px'}}>{profile.current.fanStatus.combinedStatus}</span>

                    </div>
                    <div style={{
                        backgroundColor: '#333333',
                        border : '2px solid #d1d130' , marginRight: '20px',  maxWidth : (width3) + 'px',
                        borderRadius: '5px',
                        marginTop: '5px',
                        marginLeft : width3 + 'px',
                        padding: '5px', 
                        textAlign : 'center'
                    }}>
                        <span style={{ fontFamily: 'roboto', fontSize: '20px', fontWeight: 400, color: 'white', textAlign: 'left' }}>Fanship {profile.current.points.fanPoints}</span>
                    </div>
                    <div style={{
                        backgroundColor: '#333333',
                        border : '2px solid #d1d130' , marginRight: '20px', maxWidth : (width3) + 'px',
                        borderRadius: '5px',
                        marginTop: '5px',
                        padding: '5px',
                        marginLeft : width3 + 'px',
                        textAlign : 'center'
                    }}>
                        <span style={{ fontFamily: 'roboto', fontSize: '14px', fontWeight: 400, color: 'white', textAlign: 'left' }}>Fansight {profile.current.points.researchPoints}</span>
                    </div>


                </div>
            </div>
        }

        {(profile.current !== null) && <div style={{
            backgroundColor: '#131313',
            borderRadius: '10px',
            display: 'flex',
            flexDirection: 'column',
            padding: '10px'
        }}>
            <span style={{ fontFamily: 'roboto', fontSize: '16px', fontWeight: 900, color: '#e6007e', textAlign: 'left' }}>My Interests</span>
            {
                interests.map((interest, index) => {
                    return <div style={{
                        display: 'fex',
                        flexDirection: 'column', justifyContent: 'left', textAlign: 'left'

                    }}
                    key={'profileDisplay_interestDiv_' + index}>
                        <span style={{ fontFamily: 'roboto', fontSize: '14px', fontWeight: 600, color: '#d1d130', textAlign: 'left' }}>{interest.name.trim()[0].toUpperCase() + interest.name.trim().slice(1)}</span>
                        <div style={{ display: 'flex', flexDirection: 'row' }}>
                            {interest.values.map((val) => <div style={{ backgroundColor: '#333333', borderRadius: '5px', paddingLeft: '10px', paddingRight: '10px', marginLeft: '10px', paddingBottom: '5px', marginTop: '10px', marginBottom: '10px' }}><span style={{ fontFamily: 'roboto', fontSize: '12px', fontWeight: 400, color: 'white', textAlign: 'left' }}>{val}</span></div>)}
                        </div>
                    </div>
                })
            }
        </div>}
        {(profile.current !== null) && <div style={{
            backgroundColor: '#131313',
            borderRadius: '10px',
            display: 'flex',
            flexDirection: 'column',
            padding: '10px'
        }}>
            <span style={{ fontFamily: 'roboto', fontSize: '16px', fontWeight: 900, color: '#e6007e', textAlign: 'left' }}>Recent Activity</span>
            {
                profile.current.recentActivities.map((activity, index) => {
                    return <div style={{
                        borderLeft: '2px solid #d1d130',
                        borderRight: '2px solid #d1d130',
                        marginTop: '10px',
                        display: 'flex',
                        flexDirection: 'column',
                        minWidth: (uiConfig.width - 40) + 'px',
                        maxWidth: (uiConfig.width - 40) + 'px',
                        paddingLeft: '10px', paddingRight: '10px'

                    }} key ={'ProfileDisplay_activityDiv_' + index}>
                        <div style={{
                            display: 'grid',
                            minWidth: (uiConfig.width - 60) + 'px',
                            maxWidth: (uiConfig.width - 60) + 'px',
                            gridTemplateRows: 'auto',
                            gridTemplateColumns: '1fr 1fr'
                        }}>
                            <span style={{ fontFamily: 'roboto', fontSize: '14px', fontWeight: 700, color: '#d1d130', textAlign: 'left' }}>{activity.action}</span>
                            <span style={{ fontFamily: 'roboto', fontSize: '12px', fontWeight: 400, color: '#bbbbbb', textAlign: 'right' }}>{activity.time}</span>
                        </div>
                        <span style={{ fontFamily: 'roboto', fontSize: '14px', fontWeight: 400, color: '#bbbbbb', textAlign: 'left' }}>{activity.category + ' : ' + activity.event}</span>
                    </div>
                })
            }
        </div>}
        {(profile.current !== null) && <div style={{
            backgroundColor: '#131313',
            borderRadius: '10px',
            display: 'flex',
            flexDirection: 'column',
            padding: '10px'
        }}>
            <span style={{ fontFamily: 'roboto', fontSize: '16px', fontWeight: 900, color: '#e6007e', textAlign: 'left' }}>Badges & Achievements</span>
            {
                profile.current.achievements.map((achievement, aindex) => {
                    return <div style={{
                        backgroundColor: 'black',
                        border: '2px solid ' + achievement.color,
                        borderRadius: '10px',
                        display: 'flex',
                        flexDirection: 'column',
                        minWidth: (uiConfig.width - 20) + 'px', marginTop: '10px'
                    }} key={'ProfileDisplay_achievementDiv_' + aindex}>
                        <div style={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'center'
                        }}>
                            <svg width={width3} height={width3} style={{ marginTop: '10px' }}> 
                                <g transform={badgeT[achievement.symbol]}>
                                {
                                    otherBadges.current[achievement.symbol].map((badge, bindex) => {
                                        return <path stroke={achievement.color} d={badge} strokeWidth={8} id={'ProfileDisplay_bdg_' + aindex + '_' + bindex} key={'ProfileDisplay_bdg_' + aindex + '_' + bindex} />
                                    })
                                }
                                </g>
                            </svg>
                        </div>
                        <span style={{ fontFamily: 'roboto', fontSize: '16px', fontWeight: 700, color: achievement.color, textAlign: 'center' }}>{achievement.name}</span>
                        <span style={{ fontFamily: 'roboto', fontSize: '12px', fontWeight: 400, color: achievement.color, textAlign: 'center' }}>{achievement.rarity}</span>
                        <span style={{ fontFamily: 'roboto', fontSize: '12px', fontWeight: 400, color: 'white', textAlign: 'center', marginBottom: '10px' }}>{achievement.description}</span>
                    </div>
                })
            }
        </div>}


    </div>


}